/**
 * Normalize a serial number entered by a mechanic (manual entry, barcode scan, or
 * OCR/file upload) to its canonical form. Hardware serials are case-insensitive but
 * are validated against uppercase-only patterns, so we uppercase all input rather
 * than rejecting lowercase. Nullish input collapses to an empty string.
 *
 * A sticker prints more than the serial: a label in front ("S/N:") and, on the Teltonika, a gap
 * before the last four digits ("SN:601050 3652"). Typed off the sticker both come along; the
 * barcode next to it holds neither. The label is only dropped with its colon: a serial may well
 * begin with SN, a label never lacks the colon.
 *
 * The CRM does the same before it validates and stores: App\Modules\Mechanics\Support\SerialNumber.
 */
export default function normalizeSerialNumber(value: string | null | undefined): string {
  return (value ?? '')
    .toUpperCase()
    .replace(/^\s*S\s*\/?\s*N\s*:/, '')
    .replace(/\s+/g, '');
}

/**
 * Whether a serial has the format its question names. A question that names none accepts any
 * serial, but never an empty one.
 */
export function matchesSerialPattern(
  value: string | null | undefined,
  patterns?: string[]
): boolean {
  const serial = normalizeSerialNumber(value);

  if (!serial) return false;

  if (!patterns || patterns.length === 0) return true;

  return patterns.some(pattern => new RegExp(pattern).test(serial));
}

/** An inverter's barcode carries more than its serial; the first twelve characters are it. */
export const INVERTER_SERIAL_LENGTH = 12;

/**
 * The serial in a scanned barcode. Cut to `length` characters, or whole when `length` is 0 — cut
 * to twelve, every retrofit battery scans as the same 0DVS90ED33HT.
 */
export function serialFromScan(data: string, length: number = INVERTER_SERIAL_LENGTH): string {
  return length > 0 ? data.substring(0, length) : data;
}
